export default __webpack_public_path__ + "./fonts/ingresosFuturos.18075513.svg";